// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maAdminView from '../adminView'
import maEmpty from '@/components/empty'

// api
import {
  apiGetAdminGagParameters,
  apiPatchAdminGagParameters
} from '@/services/API/adminGag'

export default {
  name: 'depreciations',
  data: function () {
    return {
      parameter: {
        paramName: null,
        paramValue: null,
        customizable: null
      }
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminGagParameters(this.currentPage)
        .then(parameters => {
          this.table = parameters.results
          this.totalPages = parameters.total_pages || 0
        })
    },
    handleEdit: function (paramName, paramValue, customizable) {
      this.parameter = { paramName, paramValue, customizable }
      this.$refs.adminGagEditModal.showModal = true
    },
    resetEditValues: function () {
      if (this.parameter) {
        Object.keys(this.parameter).forEach(parameter => { parameter = null })
      }
    },
    handleSave: function () {
      apiPatchAdminGagParameters(
        this.parameter.paramName,
        this.parameter.paramValue,
        this.parameter.customizable
      )
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminGagEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    }
  }
}
